import {
    Log, LogLevel,
} from 'one-log';

import '../../ccw-app/one-epics/authtoken/src/index';
import {
    init,
} from 'ccw-app';

import {
    loader,
} from 'one-web-loader';
import bundledTsConfig from './ts-config.json';
import {
    callSettingsApi,
    getAgentIdFromUrl,
    loadSettingsFromApi,
    prefetchSettingsAuthorization,
    waitForAgentIdInUrl,
} from 'one-ts-config';

import { enableTrace } from "one-trace";

import {
    AlertNotification
} from "one-alert-notification";

import {
    BrowserLogger,
} from 'one-web-logger';
import { HAServer, HAServerOne } from 'one-server-local-ha';

// set up the logger
const log = new Log("ccw-app",[
    new BrowserLogger(),
],LogLevel.DEBUG);

loader({
    log,
    tsConfig: bundledTsConfig,
    fetchSettings: callSettingsApi,
}, (options: any) => (
    new Promise(async (resolve) => {
        const {
            settings,
            resolver,
            tsConfig,
            tsConfigAccess,
            settingsDeferred,
        } = options;

        let activeSettings = settings;
        let fullSettingsLoaded = !settingsDeferred;

        try {
            await (prefetchSettingsAuthorization(tsConfig) ?? Promise.resolve());
            log.info('ccw-app-incontact', 'Auth token prefetched');
        } catch (exp) {
            log.error('ccw-app-incontact', 'Failed to prefetch auth token', exp);
        }

        if (settingsDeferred && getAgentIdFromUrl('inContact')) {
            try {
                activeSettings = await loadSettingsFromApi(tsConfig, {
                    fetchSettings: callSettingsApi,
                });
                fullSettingsLoaded = true;
                log.info('ccw-app-incontact', 'Full settings loaded from URL agentId');
            } catch (exp) {
                log.error('ccw-app-incontact', 'Failed to load settings before init', exp);
            }
        }

        /**
         * check for the log level config from settings and set default
         */
        const {logconfig,alertnotify} = activeSettings;
        if(logconfig?.level==="INFO"){
            log.setlevel(LogLevel.INFO);
        } else  if(logconfig?.level==="WARN"){
            log.setlevel(LogLevel.WARN);
        } else  if(logconfig?.level==="ERROR"){
            log.setlevel(LogLevel.ERROR);
        } else{
            log.setlevel(LogLevel.DEBUG);
        }
        log.debug(
            'ccw-app-web',
            'app settings', {
            settings: activeSettings,
        });

          const agentId = getAgentIdFromUrl('inContact') ?? '';
          // adding ani
          const ani = '';
          let alertnotification = new AlertNotification(false,alertnotify?.url,{
                             });
          if(alertnotify?.enable){
            alertnotification = new AlertNotification(true,alertnotify?.url,{
              customer_name:alertnotify?.customer,
              server_id:alertnotify?.servername,
              app_type:"web"
          })
          }
            // enable user specific trace
            enableTrace(agentId, {
                log,
                settings: activeSettings,
            });

        // initialize the app
        const {
            store,
            mergeSettings,
        } = await init('app', {
            log,
            tsConfigAccess,
            tsConfig,
            agentId,
            ani,
            settings: activeSettings,
            resolver,
            alertnotification,
            server: new HAServer(
                activeSettings['servers'],
                (url:string,error: any) => {
                    store.dispatch({
                        type: "one-state-errorhandle/set",
                        payload: {
                            url: url,
                            error: error,
                            monitor: false
                        }
                    })
                }
            ),
            serverone: new HAServerOne(
                activeSettings['servers'],
                (url:string,error: any) => {
                    store.dispatch({
                        type: "one-state-errorhandle/set",
                        payload: {
                            url: url,
                            error: error,
                            monitor: false
                        }
                    })
                }
            ),
        });

        let fullSettingsLoading = false;

        const applyFullSettings = async () => {
            if (fullSettingsLoaded || fullSettingsLoading) {
                return;
            }

            fullSettingsLoading = true;

            try {
                const fullSettings = await loadSettingsFromApi(tsConfig, {
                    fetchSettings: callSettingsApi,
                });
                mergeSettings(fullSettings);
                fullSettingsLoaded = true;
                log.info('ccw-app-incontact', 'Full settings loaded after login');
            } catch (exp) {
                log.error('ccw-app-incontact', 'Failed to load settings after login', exp);
            } finally {
                fullSettingsLoading = false;
            }
        };

        if (settingsDeferred && !fullSettingsLoaded) {
            waitForAgentIdInUrl('inContact')
                .then(() => applyFullSettings())
                .catch((exp) => {
                    log.error('ccw-app-incontact', 'Timed out waiting for agentId in URL', exp);
                });
        }

        resolve({
            log,
            // next is optional
            next: (params: any) => {
                console.debug(
                    'ccw-app-incontact',
                    'finished initialization...', {
                    params,
                });
                return Promise.resolve({
                    store,
                });
            },
        });
    })
));